import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ConfigService } from "../../../../core/services/config.service";

@Component({
  selector: "app-dialog-leave-tournament",
  templateUrl: "./dialog-leave-tournament.component.html",
  styleUrls: ["./dialog-leave-tournament.component.scss"],
})
export class DialogLeaveTournamentComponent {
  config;

  readonly message =
    'You are currently playing in a tournament. If you leave, your blinds will still be posted, and your hand will be folded automatically. You will be marked as "Sitting Out" and can return at any time.';

  constructor(
    public dialogRef: MatDialogRef<DialogLeaveTournamentComponent>,
    private configService: ConfigService,
  ) {
    this.config = this.configService.config;
  }

  get isNewDesign(): boolean {
    return !!this.config?.newDesign;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
